export default __webpack_public_path__ + "ad4b623a73ca5e40a556663939f4866c.woff";